export const HEALTH_CHECK = "health-check";
export const CLICK = "click";
export const INITIALIZE_REQUEST = "initialize-request";
export const RESET_IFRAME_REQUEST = "reset-iframe-request";
export const INITIALIZE_ACK = "initialize-ack";
export const INITIALIZE_SUCCESS = "initialize-success";
export const INITIALIZE_FAIL = "initialize-fail";
export const LOGIN_ACK = "login-ack";
export const LOGIN_SUCCESS = "login-success";
export const LOGIN_FAIL = "login-fail";
export const LOGIN_NO_CREDS = "login-no-creds";
export const NAVIGATE_ACK = "navigate-ack";
